import { AfterViewInit, Component, Input } from "@angular/core";
import { Contact, ContactField } from "@models";
import { TranslationService } from "@core-services/translation.service";
import { TradableListService } from "../../../services/currency/tradable_list.service";
import { Tradable } from "@models/interfaces/tradable";

@Component({
	selector: "contact-list-item",
	templateUrl: "./contact-list-item.component.html",
	styleUrls: ["./contact-list-item.component.scss"],
	standalone: false
})
export class ContactListItemComponent implements AfterViewInit {
	@Input() public contact: Contact = null;
	@Input() public query: string = "";
	@Input() public addressFilter: Tradable = null;

	private contactFields: ContactField[] = [];

	public constructor(
		private tradableListService: TradableListService,
		private translationService: TranslationService
	) {}

	public ngAfterViewInit(): void {
		this.contactFields = this.contact.getFields(false, true);
		if (this.addressFilter) {
			this.contactFields = this.contactFields.filter(
				(field) =>
					field.getSymbol() === "EMAIL" || field.getSymbol() === this.addressFilter.getSymbol().toUpperCase()
			);
		}
	}

	public getFields(): ContactField[] {
		return this.contactFields;
	}

	public getAddressIconClass(field: ContactField): string {
		if (field.getType() === "email") {
			return "bpi__icon-email font-size-13 font-bold";
		}
		if (field.getCryptocoinId() === "") {
			return "mr-0";
		}
		return this.tradableListService.getItemById(field.getCryptocoinId()).getIconCssName(true) + " font-size-17";
	}

	public getSubLine(): string {
		const count = this.contactFields.filter((field) => field.getValue().length > 0);
		return `${count.length} ${this.translationService.translate("addresses")}`;
	}
}
